import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/Windows.jpg";
import {BsWindows} from "react-icons/bs";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function WindowsPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Windows Installation Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Explore premier windows installation services in Charlotte NC. Our expert team ensures quality installations for your home renovation needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><BsWindows className={classes.servicesIcon}/> {languageContext.services.WindowsPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.WindowsPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.WindowsPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.WindowsPage.text2}</span>
                            <br/>
                            {languageContext.services.WindowsPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.WindowsPage.text4}</span>
                            <br/>
                            {languageContext.services.WindowsPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.WindowsPage.text6}</span>
                            <br/>
                            {languageContext.services.WindowsPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.WindowsPage.text8}</span>
                            <br/>
                            {languageContext.services.WindowsPage.text9}
                            <br/><br/>
                            <span>{languageContext.services.WindowsPage.text10}</span>
                            <br/>
                            {languageContext.services.WindowsPage.text11}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default WindowsPage;